import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18AddG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h18v18H0z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        strokeWidth: 0.4,
        d: "M14.497 9a.39.39 0 0 1-.387.387H9.387v4.722a.388.388 0 0 1-.774 0V9.387H3.891A.386.386 0 0 1 3.503 9c0-.214.174-.387.388-.387h4.722V3.89a.388.388 0 0 1 .774 0v4.723h4.722c.214 0 .388.173.388.387z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18AddG$1 = Svg18AddG;

export { Svg18AddG$1 as default };
